import React, { useEffect } from 'react';

import { marketingPageUrl } from '../../api/ApiClient';

const MarketingPage = () => {
  useEffect(() => {
    window.location.replace(marketingPageUrl);
  }, []);

  return <div></div>;
};

export default MarketingPage;
